export default __webpack_public_path__ + "static/media/rotgut.60c84f05.jpg";